// extracted by mini-css-extract-plugin
module.exports = {"content":"CreateStreamSetup_content__b2Dby"};